/**
 * Traduction des réponses de l'API de comptes en message affichable.
 *
 * Partagé par les pages d'authentification (`AuthPage.js`) et la page profil
 * (`Profile.js`) : un même 429 ou une même coupure réseau doit se dire de la
 * même façon des deux côtés, et ces cas se distinguent mal du corps de la
 * réponse seul (le serveur répond volontairement pareil à un email connu et à
 * un email inconnu, par exemple).
 *
 * @param t Fonction de traduction (`LanguageManager.t`).
 */

/** Erreurs communes à toutes les routes : réseau coupé/timeout, rate-limit. */
function transportError(res, t) {
    if (res.status === 0) return t("account.errors.network");
    if (res.status === 429) return t("account.errors.tooMany");
    return null;
}

export function authError(res, mode, t) {
    return transportError(res, t)
        || (mode === "register" && res.status === 409 ? t("account.errors.alreadyRegistered") : null)
        || (mode === "login" && res.status === 401 ? t("account.errors.invalidCredentials") : null)
        || (res.status === 400 ? t("account.errors.invalidInput") : null)
        || t("account.errors.generic");
}

/**
 * `POST /auth/forgot-password` répond 200 même pour un email inconnu (elle ne
 * révèle pas l'existence du compte) : le message de succès n'est juste que si
 * la route a bien été atteinte. Pas de mot de passe dans ce formulaire, donc un
 * 400 ne peut porter que sur l'email — `invalidInput` en parlerait à tort.
 */
export function forgotError(res, t) {
    return transportError(res, t)
        || (res.status === 400 ? t("account.errors.invalidEmail") : null)
        || t("account.errors.generic");
}

export function profileError(res, t) {
    return transportError(res, t)
        || (res.data?.error === "email_taken" ? t("account.errors.emailTaken") : null)
        || (res.data?.error === "username_taken" ? t("account.errors.usernameTaken") : null)
        || (res.status === 400 ? t("account.errors.invalidInput") : null)
        || t("account.errors.generic");
}
